import { useOrder } from "../context/OrderContext";
import OrderLayout from "../components/OrderLayout";
import PaymentReturnGuard from "../components/PaymentReturnGuard";
import StepProduct from "../components/steps/StepProduct";
import StepQuantity from "../components/steps/StepQuantity";
import StepPetScreen from "../components/steps/StepPetScreen";
import StepMesh from "../components/steps/StepMesh";
import StepWhiteGlove from "../components/steps/StepWhiteGlove";
import StepSummary from "../components/steps/StepSummary";
import StepCheckout from "../components/steps/StepCheckout";
import StepUpsell from "../components/steps/StepUpsell";
import StepMeasurements from "../components/steps/StepMeasurements";
import StepDone from "../components/steps/StepDone";

const COMPONENTS = {
  product: StepProduct,
  quantity: StepQuantity,
  petscreen: StepPetScreen,
  mesh: StepMesh,
  whiteGlove: StepWhiteGlove,
  summary: StepSummary,
  checkout: StepCheckout,
  upsell: StepUpsell,
  measurements: StepMeasurements,
  done: StepDone,
};

export default function OrderPage() {
  const { state } = useOrder();
  const Step = COMPONENTS[state.stepId] || StepProduct;
  return (
    <PaymentReturnGuard>
      <OrderLayout>
        <Step />
      </OrderLayout>
    </PaymentReturnGuard>
  );
}
